import { MediaPipelineProcessInfo } from "./MediaPipelineProcessInfo.model";

export class MediaProcessInfo {
  id: number;
  name: string;
  description: string;

  inputType: string;
  outputType: string;

  parameters: { [key: string]: string }
  parametersAsText: string;

  position: number;

  constructor(pipelineProcessInfo: MediaPipelineProcessInfo, availableSteps: MediaProcessInfo[]) {
    this.id = pipelineProcessInfo.mediaProcessId;
    this.parameters = pipelineProcessInfo.parameters;

    const matchingProcesses = availableSteps.filter(x => x.id == this.id);
    if (matchingProcesses.length > 0) {
      const matchingProcess = matchingProcesses[0];
      this.name = matchingProcess.name;
      this.inputType = matchingProcess.inputType;
      this.outputType = matchingProcess.outputType;
      this.description = matchingProcess.description;
    }
  }
}

